module.exports = __webpack_public_path__ + "img/chengyun55.442cabee.png";